<div class="ui-header">
  <div class="header-block">
    <div class="tool-block hamberger">
      <a href="javascript:;"  @click="onClickSideBar">
        <iCon class="icon" iconClass="asus_pacc_sw_ico_drawer_sidebar"></iCon>
      </a>
    </div>
    <div class="logo-block">
      <!-- <div style="color:white">{{$store.state.openSideBar}}</div> -->
      <a class="logo" href="javascript:;" @click="onClickLogo">{{$t('__d7d_n17r.__proArtColorCenter', {brand: brand})}}</a>
    </div>
    <div class="tool-block">
      <ul class="tool-list-block">
        <li>
          <Dropdown icon="top-language" popup_x="-60" popup_y="5" :data_up="sideInfo[0].sub" @onClick="onClickLang"
            theme="4" v-model:active="state.langSelectedIndex" @handleFocusOn="handleProfileFocusOut"></Dropdown>
          <!-- <iCon class="icon" iconClass="top-language"></iCon> -->
        </li>
        <li>
          <a href="javascript:;" @click="onClickContact">
            <iCon class="icon" iconClass="top-email_n"></iCon>
          </a>
        </li>
        <li>
          <a href="javascript:;" tabindex="-1">
            <!-- <iCon class="icon" iconClass="top-info_n"></iCon> -->
            <Dropdown icon="top-info_n" theme="3" popup_x="-60" popup_y="5" :data_up="sideInfo[1].sub"
              @onClickIndex="onClickInfo($event)" @handleFocusOn="handleProfileFocusOut"></Dropdown>
          </a>
        </li>
        <li>
          <a href="javascript:;" @click="onClickNotification">
            <iCon class="icon" iconClass="asus_proart_sw_ico_notification" ></iCon>
            <div class="dot" v-if="$store.state.alertNotification">{{$store.state.isRWDBreakingPoint ? '' : $store.state.alertNotification}}</div>
          </a>
        </li>
      </ul>
      <!-- end tool-block -->
      <div class="right-block style--more" :class="styleProfileShow">
        <a href="javascript:;" v-click-outside="handleProfileFocusOut" class="right-item-block profile-block"
          @click="onClickProfile">
          <i class="icon-block">
            <iCon class="icon user-icon" iconClass="top-accounts_portrait_n"></iCon>
          </i>
          <span class="text-block">
            {{userName}}
          </span>
        </a>
        <div class="detail-block" v-if="state.isShowProfile">
          <div class="img-block">
            <iCon class="icon user-icon" iconClass="top-accounts_portrait_n"></iCon>
          </div>
          <p class="text--main">{{userName}}</p>
          <p class="text--sub">{{email}}</p>
          <div class="btn-block">
            <Button type="border" id="GTM__notificationCenter" h="sm" colors="main" :text="$t('__main.__logOut')" @onClick="logout"></Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>